/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RotateCredentialsRequestBody,
  RotateCredentialsRequestBody$Outbound,
  RotateCredentialsRequestBody$outboundSchema,
} from "../components/rotatecredentialsrequestbody.js";

export type RotateNetworkIngressCredentialsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RotateNetworkIngressCredentialsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  rotateCredentialsRequestBody: RotateCredentialsRequestBody;
};

/** @internal */
export type RotateNetworkIngressCredentialsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RotateNetworkIngressCredentialsSecurity$outboundSchema:
  z.ZodMiniType<
    RotateNetworkIngressCredentialsSecurity$Outbound,
    RotateNetworkIngressCredentialsSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function rotateNetworkIngressCredentialsSecurityToJSON(
  rotateNetworkIngressCredentialsSecurity:
    RotateNetworkIngressCredentialsSecurity,
): string {
  return JSON.stringify(
    RotateNetworkIngressCredentialsSecurity$outboundSchema.parse(
      rotateNetworkIngressCredentialsSecurity,
    ),
  );
}

/** @internal */
export type RotateNetworkIngressCredentialsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  RotateCredentialsRequestBody: RotateCredentialsRequestBody$Outbound;
};

/** @internal */
export const RotateNetworkIngressCredentialsRequest$outboundSchema:
  z.ZodMiniType<
    RotateNetworkIngressCredentialsRequest$Outbound,
    RotateNetworkIngressCredentialsRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      rotateCredentialsRequestBody: RotateCredentialsRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        rotateCredentialsRequestBody: "RotateCredentialsRequestBody",
      });
    }),
  );

export function rotateNetworkIngressCredentialsRequestToJSON(
  rotateNetworkIngressCredentialsRequest:
    RotateNetworkIngressCredentialsRequest,
): string {
  return JSON.stringify(
    RotateNetworkIngressCredentialsRequest$outboundSchema.parse(
      rotateNetworkIngressCredentialsRequest,
    ),
  );
}
